export const apparelColors = {
  sweatshirt: [
    { code: "000", name: "White", hex: "#ffffff" },
    { code: "110", name: "Ash", hex: "#CFCDCD" },
    { code: "145", name: "Grey melange", hex: "#9E9898" },
    { code: "135", name: "Steel grey", hex: "#616a74" },
    { code: "180", name: "Charcoal", hex: "#3A3738" },
    { code: "199", name: "Black", hex: "#000000" },
    { code: "230", name: "Raspberry", hex: "#ac235b" },
    { code: "250", name: "Red", hex: "#ff0000" },
    { code: "280", name: "Wine red", hex: "#762938" },
    { code: "320", name: "Light blue", hex: "#bed9ed" },
    { code: "340", name: "Turquoise", hex: "#00c8d4" },
    { code: "360", name: "Cornflower blue", hex: "#0856ab" },
    { code: "380", name: "Navy", hex: "#081e49" },
    { code: "385", name: "Navy Melange", hex: "#404A5F" },
    { code: "420", name: "Lime", hex: "#bae55f" },
    { code: "460", name: "Kelly green", hex: "#169746" },
    { code: "472", name: "Light Olive", hex: "#747963" },
    { code: "480", name: "Bottle green", hex: "#22483f" },
    { code: "630", name: "Safety yellow", hex: "#e1e400" },
    { code: "650", name: "Yellow", hex: "#ffce00" },
    { code: "690", name: "Orange", hex: "#e97300" },
    { code: "680", name: "Safety orange", hex: "#ff5200" },
  ],
  tshirt: [
    { code: "000", name: "White", hex: "#ffffff" },
    { code: "199", name: "Black", hex: "#000000" },
    { code: "210", name: "Pink", hex: "#f3bcd4" },
    { code: "230", name: "Raspberry", hex: "#ac235b" },
    { code: "250", name: "Red", hex: "#ff0000" },
    { code: "330", name: "Heaven blue", hex: "#8f9EEB" },
    { code: "360", name: "Cornflower blue", hex: "#0856ab" },
    { code: "380", name: "Navy", hex: "#081e49" },
    { code: "333", name: "Petrol Blue", hex: "#003557" },
    { code: "420", name: "Lime", hex: "#bae55f" },
    { code: "472", name: "Light Olive", hex: "#747963" },
    { code: "650", name: "Yellow", hex: "#ffce00" },
    { code: "690", name: "Orange", hex: "#e97300" },
    { code: "185", name: "Anthracite", hex: "#4c4d4d" },
    { code: "285", name: "Dark Burgundy", hex: "#46323e" },
    { code: "455", name: "Dark Green", hex: "#385e47" },
    { code: "783", name: "Lavender", hex: "#c1b8d4" },
  ],
  hoodie: [
    { code: "000", name: "White", hex: "#ffffff" },
    { code: "199", name: "Black", hex: "#000000" },
    { code: "210", name: "Pink", hex: "#f3bcd4" },
    { code: "250", name: "Red", hex: "#ff0000" },
    { code: "330", name: "Heaven blue", hex: "#8f9EEB" },
    { code: "360", name: "Cornflower blue", hex: "#0856ab" },
    { code: "380", name: "Navy", hex: "#081e49" },
    { code: "185", name: "Anthracite", hex: "#4c4d4d" },
    { code: "285", name: "Dark Burgundy", hex: "#46323e" },
    { code: "455", name: "Dark Green", hex: "#385e47" },
  ],
  "zip-hoodie": [
    { code: "000", name: "White", hex: "#ffffff" },
    { code: "014", name: "Offwhite", hex: "#fffdf0" },
    { code: "110", name: "Ash melange", hex: "#CECCCD" },
    { code: "145", name: "Grey melange", hex: "#9E9898" },
    { code: "180", name: "Charcoal", hex: "#3A3738" },
    { code: "199", name: "Black", hex: "#000000" },
    { code: "250", name: "Red", hex: "#ff0000" },
    { code: "340", name: "Turquoise", hex: "#00c8d4" },
    { code: "360", name: "Cornflower blue", hex: "#0856ab" },
    { code: "380", name: "Navy", hex: "#081e49" },
    { code: "385", name: "Navy Melange", hex: "#404A5F" },
    { code: "339", name: "Emerald", hex: "#34555a" },
    { code: "630", name: "Safety yellow", hex: "#e1e400" },
    { code: "333", name: "Petrol Blå", hex: "#335674" },
    {
      code: "915",
      name: "Black/Grey Melange",
      hex: "#1a1a1a",
      swatch: ["#000000", "#9E9898"],
    },
    {
      code: "918",
      name: "Grey Melange/Black",
      hex: "#8f8b8b",
      swatch: ["#9E9898", "#000000"],
    },
    {
      code: "931",
      name: "Navy/Grey Melange",
      hex: "#142b50",
      swatch: ["#081E49", "#9E9898"],
    },
    {
      code: "934",
      name: "Corn Blue/Grey Melange",
      hex: "#2f63c2",
      swatch: ["#0856AB", "#9E9898"],
    },
  ],
};

export const getApparelColorHexes = (productId) =>
  apparelColors[productId].map((color) => color.hex);

export const getApparelColorOption = (productId, hex) => {
  if (!hex) return "";

  return apparelColors[productId]?.find(
    (option) => option.hex.toLowerCase() === String(hex).toLowerCase(),
  );
};

export const getApparelColorLabel = (productId, hex) => {
  const color = getApparelColorOption(productId, hex);

  return color ? `${color.code} ${color.name}` : "";
};

export const getApparelColorPrimaryHex = (productId, hex) => {
  const color = getApparelColorOption(productId, hex);

  return color?.swatch?.[0] ?? color?.hex ?? hex ?? "";
};

export const getApparelColorSwatchStyle = (productId, hex) => {
  const color = getApparelColorOption(productId, hex);

  if (color?.swatch?.length >= 2) {
    const [primary, secondary] = color.swatch;
    return {
      backgroundImage: `linear-gradient(135deg, ${primary} 0 50%, ${secondary} 50% 100%)`,
    };
  }

  return { backgroundColor: color?.hex ?? hex ?? "#ffffff" };
};
